module.exports = __webpack_public_path__ + "img/animated-discord.cd30721b.gif";